import _ from 'lodash';

import AI_CONDITIONS from './resources/conditions';

export default function buildFormConditions(formPrefixId, disclaimerCheckboxKey, disclaimerHtmlKey, submitButtonKey) {
	const result = _.cloneDeep(AI_CONDITIONS);
	const processSubIds = (item) => {
		if (item.subId) {
			const subIdWithPrefix = item.subId + formPrefixId;
			item.key = `${item.key}_${subIdWithPrefix}`;
		} else {
			if (item.key === '{disclaimer_html}') {
				item.key = disclaimerHtmlKey;
			}
			if (item.key === '{i_have_read_the_disclaimer}') {
				item.key = disclaimerCheckboxKey;
			}
			if (item.key === '{send}') {
				item.key = submitButtonKey;
			}
		}
		return item;
	};
	return result.map((item) => {
		item.when.map(processSubIds);
		item.then.map(processSubIds);

		return item;
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/buildFormConditions.js